/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { loadUser } from '@store/actions/user.actions';
import { IAppState } from '@store/app.state';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { User } from '../../domain/interface/user.interface';
import { AccountsUseCaseService } from '../../features/profile/application/accounts-use-case.service';

export const userResolver: ResolveFn<Promise<User>> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<User> => {
    const accountService = inject(AccountsUseCaseService);
    const store = inject(Store<IAppState>);
    const router = inject(Router);

    const user = await firstValueFrom(accountService.getUser());
    store.dispatch(loadUser({ user }));
    const { status } = user;

    if (status === 'PENDING_ACCEPT_TERMS_AND_CONDITIONS') {
        router.navigate(['registration/sign-terms-policy']);
    } else if (status === 'PENDING_REVIEW_USER_INFO') {
        router.navigate(['registration/confirm-account']);
    }
    return user;
};
